export default __webpack_public_path__ + "assets/webgl/scene.46e5d64c.glb";